import { useEffect, useState } from "react";

const KEY = "omnimist_sale_end";
const WINDOW_MS = 24 * 60 * 60 * 1000;

const getTarget = () => {
  try {
    const t = Number(localStorage.getItem(KEY));
    if (t && t > Date.now()) return t;
  } catch (e) {}
  const t = Date.now() + WINDOW_MS;
  try {
    localStorage.setItem(KEY, String(t));
  } catch (e) {}
  return t;
};

export default function CountdownTimer({ compact = false }) {
  const [target] = useState(getTarget);
  const [left, setLeft] = useState(() => Math.max(0, target - Date.now()));

  useEffect(() => {
    const i = setInterval(() => setLeft(Math.max(0, target - Date.now())), 1000);
    return () => clearInterval(i);
  }, [target]);

  const s = Math.floor(left / 1000);
  const pad = (n) => String(n).padStart(2, "0");
  const time = `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;

  if (compact) {
    return (
      <span
        className="flex items-center gap-1.5 font-mono text-xs font-semibold text-gold"
        data-testid="sale-countdown-compact"
      >
        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-gold" />
        {time}
      </span>
    );
  }

  return (
    <div className="mt-3 flex items-center gap-2.5" data-testid="sale-countdown">
      <span className="text-xs font-semibold uppercase tracking-[0.16em] text-charcoal-500">
        Sale ends in
      </span>
      <span className="rounded-lg bg-charcoal-900 px-2.5 py-1.5 font-mono text-sm font-semibold text-oat-100 tabular-nums">
        {time}
      </span>
    </div>
  );
}
